import React from 'react'
import './Projects.css'
import logo from './logo.svg'

function Projects (){
    return (
        <div className="projects-wrapper">
            <h1>My Projects</h1>
            <div className="projects-container">
                <div className = 'container1'>
                    <div className="project-content">
                        <div className="project-text">
                            <h1>Stock Market & Crypto Visual</h1>
                            <p>Currently working on a full-stack project of getting live updates about the stock market as well as Crypto.</p>
                            <p>Tools: React, Firebase, FinHub API</p>
                            <p>Still in development...</p>
                        </div>
                        <div className="project-image">
                            <div className="image-container">
                                <img src="/StockMarket.jpg" alt="Stock Market Visual Screenshot" className="project-screenshot" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className = 'container2'>
                    <div className="project-content">
                        <div className="project-text">
                            <h1>Neural Network From Scratch</h1>
                            <p>Creating a Neural Network on C++ without any external libraries. Starting with custom neuron design, weight initialization, activation functions, and forward pass computation. Planned features include adding mult-layers and training dataset.</p>
                            <p>Tools: C++, Git</p>
                            <p>Still in development...</p>
                        </div>
                        <div className="project-image">
                            <div className="image-container">
                                <img src="/NN.png" alt="Neural Network Diagram" className="project-screenshot" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Projects
